import Vue from "vue";
import store from "@/general/store";
import loginInfo from "@/general/store/modules/loginInfo";
import PortalVue from "portal-vue";
import vuescroll from "vue-scrollto";
import Vue2TouchEvents from "vue2-touch-events";
import { mapMutations, mapState } from "vuex";
import modalState from "../common/store/modules/modalState";
import WhatsNew from "@/general/components/pages/WhatsNew.vue";
import PointConfirmation from "@/general/components/pages/PointConfirmation.vue";
import PointHistorySearch from "@/general/components/pages/PointHistorySearch.vue";
import NoPointHistory from "@/general/components/pages/NoPointHistory.vue";
import PointHistoryGrantedInfo from "@/general/components/pages/PointHistoryGrantedInfo.vue";
import PointHistoryGiftInfo from "@/general/components/pages/PointHistoryGiftInfo.vue";
import ExpiringPoints from "@/general/components/pages/ExpiringPoints.vue";
import ExpiredPoints from "@/general/components/pages/ExpiredPoints.vue";
import PointHistoryUsageInfo from "@/general/components/pages/PointHistoryUsageInfo.vue";
import GrantCriteria from "@/general/components/pages/GrantCriteria.vue";
import ProfileUpdate from "@/general/components/pages/ProfileUpdate.vue";
import GrantCriteriaDetails from "@/general/components/pages/GrantCriteriaDetails.vue";
import GrantCriteriaListNone from "@/general/components/pages/GrantCriteriaListNone.vue";
import ThanksPointList from "@/general/components/pages/ThanksPointList.vue";
import ThanksPointNoGifts from "@/general/components/pages/ThanksPointNoGifts.vue";
import ThanksPointMessage from "@/general/components/pages/ThanksPointMessage.vue";
import ThanksPointSearchMore from "@/general/components/pages/ThanksPointSearchMore.vue";
import ThanksPointUserSelection from "@/general/components/pages/ThanksPointUserSelection.vue";
import GiveThanksPoint from "@/general/components/pages/GiveThanksPoint.vue";
import GiveThanksPointConfirmation from "@/general/components/pages/GiveThanksPointConfirmation.vue";
import ProductList from "@/general/components/pages/ProductList.vue";
import WhatsNewDetails from "@/general/components/pages/WhatsNewDetails.vue";
// import CmsSpecialPage from "@/general/components/pages/CmsSpecialPage.vue";
import CmsSpecialPageDetail from "@/general/components/pages/CmsSpecialPageDetail.vue";
import commons from "../common/store/modules/commons";
import globals from "./store/modules/globals";
import MyPage from "@/general/components/pages/MyPage.vue";
import MyPageEmailSettings from "@/general/components/pages/MyPageEmailSettings.vue";
import MyPageEmailConfirmation from "@/general/components/pages/MyPageEmailConfirmation.vue";
import MyPageIdentityVerification from "@/general/components/pages/MyPageIdentityVerification.vue";
import MyPageEmailSettingsDone from "@/general/components/pages/MyPageEmailSettingsDone.vue";
import MyPageEmailSettingsError from "@/general/components/pages/MyPageEmailSettingsError.vue";
import PersonalInfoUpdate from "@/general/components/pages/PersonalInfoUpdate.vue";
import SecretQuestion from "@/general/components/pages/SecretQuestion.vue";
import TermsOfService from "@/general/components/pages/TermsOfService.vue";
import MailDeliverySettings from "@/general/components/pages/MailDeliverySettings.vue";
import ProductDetails from "@/general/components/pages/ProductDetails.vue";
import TopPage from "@/general/components/pages/TopPage.vue";
import Favorite from "@/general/components/pages/Favorite.vue";
import BrowserHistory from "@/general/components/pages/BrowserHistory.vue";
import Ranking from "@/general/components/pages/Ranking.vue";
import K1Notification from "@/general/components/pages/K1Notification.vue";
import ExpiringPointDetails from "@/general/components/pages/ExpiringPointDetails.vue";
import ExpiredPointDetails from "@/general/components/pages/ExpiredPointDetails.vue";
import NotContractedIc from "@/general/components/pages/NotContractedIc.vue";
import ProductTop from "@/general/components/pages/ProductTop.vue";
import AuthenticationCallback from "@/general/components/pages/AuthenticationCallback.vue";
import Logout from "@/general/components/pages/Logout.vue";
import { http as axios } from "@/general/utils/http";
import AuthApi from "./api/authApi";

// TODO useless -- start
// import ThanksPointSearchResult from "@/general/components/pages/ThanksPointSearchResult.vue";
// import ThanksPointListSearchNotFound from "@/general/components/pages/ThanksPointListSearchNotFound.vue";
// import Bpflogin from "@/general/components/pages/Bpflogin.vue";
// import SelectContract from "@/general/components/pages/SelectContract.vue";
// import ExpiredContractDate from "@/general/components/pages/ExpiredContractDate.vue";
// import Dashboard from "@/general/components/pages/Dashboard.vue";
// import CartDetails from "@/general/components/pages/CartDetails.vue";
// import ApplyCartItems from "@/general/components/pages/ApplyCartItems.vue";
// import ApplyCartItemsConfirm from "@/general/components/pages/ApplyCartItemsConfirm.vue";
// import ApplyCartItemsApplicationComplete from "@/general/components/pages/ApplyCartItemsApplicationComplete.vue";
// import ApplyCartItemsApplicationFinished from "@/general/components/pages/ApplyCartItemsApplicationFinished.vue";
// import ApplyCartItemsApplicationCancel from "@/general/components/pages/ApplyCartItemsApplicationCancel.vue";
// import Login from "@/general/components/pages/Login.vue";
// import RegistrationDone from "@/general/components/pages/RegistrationDone.vue";
// import RegistrationInput from "@/general/components/pages/RegistrationInput.vue";
// import RegistrationConfirmation from "@/general/components/pages/RegistrationConfirmation.vue";
// import RegistrationEmailConfirmation from "@/general/components/pages/RegistrationEmailConfirmation.vue";
// import LoginLinksDemo from "@/general/components/pages/LoginLinksDemo.vue";
// TODO useless -- end

import ThePageError from "@/common/components/pages/ThePageError.vue";
import SwitchSite from "@/common/components/pages/SwitchSite.vue";
import TermsAndConditions from "@/common/components/pages/TermsAndConditions.vue";

import "@/general/assets/css/style.scss";
import "@/general/main.components";
import jQuery from "jquery";
import SITE_MAP from "./mixins/const/custom/sitemap";
window.$ = jQuery;
window.jQuery = jQuery;

Vue.config.productionTip = false;
Vue.use(PortalVue);
Vue.use(Vue2TouchEvents);
Vue.use(vuescroll);

require("@/common/assets/js/plugins/dayjs");
require("@/common/assets/js/plugins/axios");
Vue.config.devtools = true;

async function initializedApp() {
  let isInitialized = false;
 
  const app = new Vue({
    components: {
      WhatsNew,
      WhatsNewDetails,
      // CmsSpecialPage,
      CmsSpecialPageDetail,
      ThanksPointList,
      ThanksPointNoGifts,
      ThanksPointMessage,
      ThanksPointSearchMore,
      ThanksPointUserSelection,
      GiveThanksPoint,
      GiveThanksPointConfirmation,
      GrantCriteria,
      GrantCriteriaDetails,
      GrantCriteriaListNone,
      ProductList,
      PointConfirmation,
      PointHistoryUsageInfo,
      NoPointHistory,
      PointHistoryGrantedInfo,
      PointHistoryGiftInfo,
      ExpiringPoints,
      ExpiredPoints,
      PointHistorySearch,
      MyPage,
      MyPageEmailSettings,
      MyPageEmailConfirmation,
      MyPageIdentityVerification,
      MyPageEmailSettingsDone,
      MyPageEmailSettingsError,
      ProfileUpdate,
      PersonalInfoUpdate,
      SecretQuestion,
      TermsOfService,
      MailDeliverySettings,
      ProductDetails,
      TopPage,
      Favorite,
      BrowserHistory,
      Ranking,
      K1Notification,
      ThePageError,
      SwitchSite,
      TermsAndConditions,
      ExpiringPointDetails,
      ExpiredPointDetails,
      NotContractedIc,
      ProductTop,
      AuthenticationCallback,
      Logout
      // TODO useless -- start
      // TheDataRegister,
      // OrganizationList,
      // LoginLinksDemo,
      // Login,
      // RegistrationDone,
      // RegistrationInput,
      // RegistrationConfirmation,
      // RegistrationEmailConfirmation,
      // Bpflogin,
      // SelectContract,
      // ExpiredContractDate,
      // CartDetails,
      // ApplyCartItems,
      // ApplyCartItemsConfirm,
      // ApplyCartItemsApplicationComplete,
      // ApplyCartItemsApplicationFinished,
      // ApplyCartItemsApplicationCancel,
      // TODO useless -- end
    },
    store,
    // vue-cli ローカル開発のエントリーファイル
    // render: h => h(App),
    computed: {
      ...mapState({
        closeModalState: () => modalState.closeModalState,
        userAgent: () => globals.userAgent
      })
    },
    methods: {
      ...mapMutations({
        setCloseModalState: () => modalState.setCloseModalState
      })
    },
    mounted: async () => {
      modalState.switchCloseModalState();

      const headerInfo: any = {
        switch: {
          general: {
            text: "管理に切替",
            url: SITE_MAP.DEFAULT
          },
          admin: {
            text: "一般に切替",
            url: SITE_MAP.DEFAULT
          }
        },
        pageType: "general"
      };

      commons.setHeaderInfo(headerInfo);

      await globals.getisSpScreenWidth();
      await globals.getScrollDirection();
      await globals.getUserAgent();

      const userAgent: any = globals.userAgent;
      const documentTitle = commons.OrgPageSpecific?.page_title;
      document.title = documentTitle?.toString() ? documentTitle?.toString() : "";

      const isiOS =
        userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1;
      if (isiOS) {
        const viewport = document.querySelector('meta[name="viewport"]');
        if (viewport) {
          const viewportContent = viewport.getAttribute("content");
          viewport.setAttribute(
            "content",
            viewportContent + ", user-scalable=no"
          );
        }
      }
    },
    beforeDestroy: () => {
      modalState.setCloseModalState(false);
    },
    async beforeCreate() {
      const path = window.location.pathname;

      // 遷移元を取得
      const referrer = document.referrer;
      // .incp.benefit-on.inc/以外のドメインから遷移してきた場合
      // トップは先頭の「.」がいらないので除外
      // ログアウト後ページと/authentication/cb/では呼び出し不要なため処理除外
      const app_domain = process.env.VUE_APP_COOKIE_DOMAIN?.slice(1);
      if (
        (app_domain === undefined || !referrer.includes(app_domain)) &&
        path !== "/authentication/cb/" &&
        path !== "/session-time-out/" &&
        path !== "/logout/"
      ) {
        // SSOFLGの取得
        const bsffSessionResult = await AuthApi.getBsffSessionInfo();
        if ((bsffSessionResult as any)?.ssoFlg === true) {
          loginInfo.setSsoFlg(true);
        } else {
          loginInfo.setSsoFlg(false);
        }
      }
      
      const ssoFlg = loginInfo.isSso;

      if (
        path !== "/authentication/cb/" &&
        path !== "/v1/top/login" &&
        path !== "/v1/top/logout" &&
        path !== "/session-time-out/" &&
        path !== "/logout/"
      ) {
        await axios
          .get("/v1/ssocheck/IC/")
          .then((res) => {
            // SSOチェックの応答に基づいて遷移処理を行う
            switch (res.status) {
              case 200:
                break;
              case 401:
                window.location.href = "/authentication/cb/?ssocheck=select";
                break;
              case 403:
                if (ssoFlg) {
                  // SSOログイン時はログアウトして行き止まり画面へ遷移する
                  window.location.href = "/session-time-out/";
                } else {
                  window.location.href =
                    process.env.VUE_APP_AUTHORIZATION + "/v1/top/login";
                }
                break;
              default:
                break;
            }
          })
          .catch((error) => {
            switch (error.response.status) {
              default:
                break;
            }
          });
      }
      this.$emit('initialized');
      isInitialized = true;
    }
  });

  await new Promise<void>(resolve => {
    if (isInitialized){
      resolve();
    }
    app.$once('initialized', resolve);
  });
  app.$mount("#app");

  return app;
}

if(initializedApp() == null){
  console.log("initialized failed");
}

